import {
  Home, Car, BookOpen, MonitorSmartphone, Dog,
  HeartHandshake, Flower2, MoreHorizontal,
} from "lucide-react";

// Categories: structural data only. Labels/hints come from i18n via t(`categories.${id}.label`).
export const CATEGORY_IDS = ["home", "transport", "study", "technology", "pets", "elderly", "gardening", "other"];

export const CATEGORY_ICONS = {
  home: Home,
  transport: Car,
  study: BookOpen,
  technology: MonitorSmartphone,
  pets: Dog,
  elderly: HeartHandshake,
  gardening: Flower2,
  other: MoreHorizontal,
};

// Badges: id + emoji only. Names/descriptions come from i18n via t(`badges.${id}.name`).
export const BADGE_IDS = ["new_member", "active_member", "supporter", "ambassador", "world_builder"];

export const BADGE_EMOJIS = {
  new_member: "🌱",
  active_member: "🤝",
  supporter: "💙",
  ambassador: "⭐",
  world_builder: "🌍",
};
